(function () {
  'use strict';

  var previousFocus = null;
  var activeContainer = null;
  var keydownHandler = null;

  function focusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function onKeydown(event) {
    if (!activeContainer) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      var closeBtn = activeContainer.querySelector('.bb__modal--close');
      if (closeBtn) closeBtn.click();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = focusableElements(activeContainer);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  function activateModal(container) {
    activeContainer = container;
    previousFocus = document.activeElement;

    // Move focus to close button or first focusable element
    var closeBtn = container.querySelector('.bb__modal--close');
    var target = closeBtn || focusableElements(container)[0] || container;

    // Slight delay so React has finished rendering
    setTimeout(function () {
      if (target) target.focus();
    }, 50);

    if (keydownHandler) document.removeEventListener('keydown', keydownHandler);
    keydownHandler = onKeydown;
    document.addEventListener('keydown', keydownHandler);
  }

  function deactivateModal() {
    activeContainer = null;

    if (keydownHandler) {
      document.removeEventListener('keydown', keydownHandler);
      keydownHandler = null;
    }

    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }
    previousFocus = null;
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        // React portals add .bb__modal directly to <body>
        var modal = node.classList && node.classList.contains('bb__modal')
          ? node
          : node.querySelector && node.querySelector('.bb__modal');
        if (modal) {
          var container = modal.querySelector('.bb__modal--container');
          if (container) activateModal(container);
        }
      });

      mutation.removedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var wasModal = node.classList && node.classList.contains('bb__modal');
        var hadModal = node.querySelector && node.querySelector('.bb__modal');
        if (wasModal || hadModal) deactivateModal();
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
